import React from "react";
import PropTypes from "prop-types";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const MPopper = ({children, anchorEl: {current}, onClickAway, useWidth, useHeight, ...otherProps}) => {
  return (
  <Popper 
    {...otherProps}
    anchorEl={current}
    sx={{ zIndex: 1 }}
    transition
    disablePortal
  >
    {({TransitionProps}) => (
      <Fade {...TransitionProps} timeout={350}>
        <Card sx={{
          width: (useWidth && current) ? current.clientWidth : undefined,
          height: (useHeight && current) ? current.clientHeight : undefined,
        }}>
          <ClickAwayListener onClickAway={({target}) => (current && !current.contains(target)) && onClickAway()}>
            <CardContent>
              {children}
            </CardContent>
          </ClickAwayListener>
        </Card>
      </Fade>
    )}
  </Popper>
  );
};

MPopper.propTypes = {
  children: PropTypes.element, //The content of the MPopper
  anchorEl: PropTypes.node, //The DOM node that the MPopper will position itelf off of
  onClickAway: PropTypes.func, //Callback for reacting to clicking away from the MPopper
  useWidth: PropTypes.bool, //If true the MPopper will match the width of the DOM target
  useHeight: PropTypes.bool, //IF true the MPopper will match the height of the DOM target
};

export default MPopper;